function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.899 2.634C4.416 1.827 2.725 1.178.833.728l.08-.35h7.754c1.052.036 1.905.35 2.182 1.458l1.685 7.976.517 2.402L17.77.377h5.097l-7.576 17.341h-5.097L5.899 2.634zm20.718 15.102h-4.82L24.81.377h4.82l-3.014 17.36zM44.089.802l-.655 3.748-.436-.184a8.707 8.707 0 00-3.59-.665c-1.904 0-2.757.757-2.777 1.496 0 .812 1.033 1.348 2.718 2.142 2.777 1.237 4.066 2.752 4.046 4.728-.039 3.601-3.331 5.928-8.389 5.928-2.162-.018-4.245-.444-5.375-.924l.674-3.897.635.278c1.567.647 2.598.923 4.522.923 1.388 0 2.876-.536 2.895-1.699 0-.757-.634-1.312-2.499-2.161-1.824-.831-4.264-2.216-4.224-4.71.02-3.379 3.372-5.742 8.132-5.742 1.865 0 3.373.387 4.323.739zm6.406 10.785h4.007c-.199-.868-1.111-5.023-1.111-5.023l-.337-1.496c-.238.646-.654 1.699-.634 1.662 0 0-1.528 3.86-1.925 4.857zm5.95-11.21l3.888 17.36h-4.462s-.437-1.995-.576-2.605h-6.188l-1.011 2.604h-5.058l7.16-15.919c.495-1.126 1.369-1.44 2.519-1.44h3.728z"
});

var SvgLogoVisa = function SvgLogoVisa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 61,
    height: 18,
    viewBox: "0 0 61 18",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoVisa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-visa.5337066d.svg";
export { ForwardRef as ReactComponent };